module.exports = __webpack_public_path__ + "img/guideshare.223c2509.png";